export const TeamliveSettingsAuditRoutes = [
    {
        "url": "/tl-settings-audit",
        "name": "appLayout.schedule.tl-settings-audit",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {},
        "views": {
            "body": {
                "component": "teamliveSettingsAudit"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["teamlive-settings-audit", "centralized-settings"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/teamlive-settings-audit/teamlive-settings-audit.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=teamlive-settings-audit.routes.js.map